import { render, staticRenderFns } from "./VideoCourseListTab.vue?vue&type=template&id=5f03f0e2"
import script from "../../services/teacher/video-course.js?vue&type=script&lang=js&external"
export * from "../../services/teacher/video-course.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/teacher/dashboard-teacher.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "../../assets/css/teacher/course-list.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports